export default "/_next/static/images/product_inbox-85bde099fd7f2abacc4dc3dd7dc4d9f0.svg";